import { render } from "./Region.vue?vue&type=template&id=b58aa138&scoped=true&ts=true"
import script from "./Region.ts?vue&type=script&lang=ts"
export * from "./Region.ts?vue&type=script&lang=ts"

import "./Region.scss?vue&type=style&index=0&id=b58aa138&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58aa138"]])

export default __exports__